<script lang="ts">
  /**
   * The waiting room.
   *
   * A pending account signs in successfully and lands here (brief §11.6). Refusing the login
   * would look like a broken passkey, and the natural response to a broken passkey is to
   * register again — which is exactly the pile of duplicate accounts this avoids.
   */
  import { session, type User } from './session.svelte.ts';

  const { user }: { user: User } = $props();
</script>

<div class="wrap">
  <div class="card">
    <span class="emoji">⏳</span>
    {#if user.status === 'suspended'}
      <h1>Konto gesperrt</h1>
      <p>Dein Konto wurde gesperrt. Deine Passkeys bleiben erhalten — Entsperren ist ein Klick.</p>
    {:else}
      <h1>Fast geschafft, @{user.username}</h1>
      <p>
        Dein Passkey ist angelegt. Ein Admin muss dein Konto noch freischalten — das ist mit
        Absicht so: die Instanz ist für einen Freundeskreis, nicht fürs Internet.
      </p>
      <p class="hint">Diese Seite aktualisiert sich, sobald du freigeschaltet bist.</p>
    {/if}
    <button onclick={() => session.signOut()}>Abmelden</button>
  </div>
</div>

<style>
  .wrap { display: grid; place-items: center; min-height: 100%; padding: 1.5rem; }

  .card {
    width: min(24rem, 100%);
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    align-items: center;
    padding: 2rem 1.5rem;
    border: 1px solid var(--border);
    border-radius: 1.25rem;
    background: var(--card);
    text-align: center;
  }

  .emoji { font-size: 2.5rem; }
  h1 { margin: 0; font-size: 1.25rem; }
  p { margin: 0; color: var(--muted); }
  .hint { font-size: 0.8125rem; }

  button {
    margin-top: 0.5rem;
    padding: 0.6rem 1.2rem;
    border: 1px solid var(--border);
    border-radius: 0.6rem;
    background: var(--bg);
    color: var(--fg);
    cursor: pointer;
  }
</style>
